import React, { FC, memo, useMemo } from "react";
import { IBlockCardProps } from "types/components/common/blockCard";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import Image from "components/common/Image";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { useHomeImages } from "context/HomeMajorImages";

const BlockCard: FC<IBlockCardProps> = ({
  item: { title, profile_images, _id: id },
  ariaCardSize,
  ...rest
}) => {
  const { resolveImage } = useHomeImages();
  const random = useMemo(
    () => Math.floor(Math.random() * profile_images.length),
    [profile_images]
  );
  const navigate = useNavigate();
  const { language } = useAppSelector(getSettings);

  return (
    <div
      className={styles["block-card-wrapper"]}
      onClick={() => navigate(`/${id}`)}
      {...(ariaCardSize && { "aria-card-size": ariaCardSize })}
    >
      <div className={styles["block-card__title"]}>
        <h3 className="text-base font-regular">{title[language]}</h3>
      </div>
      <Image
        alt="card-img"
        // src={process.env.REACT_APP_CLOUDFRONT_URL + profile_images?.[random]}
        className={styles["block-card-img"]}
        src={process.env.REACT_APP_CLOUDFRONT_URL + resolveImage(profile_images?.[random], profile_images)}
      />
    </div>
  );
};

export default memo(BlockCard, (prevProps, nextProps) => {
  return (
    prevProps.item._id === nextProps.item._id &&
    prevProps.ariaCardSize === nextProps.ariaCardSize &&
    JSON.stringify(prevProps.item.profile_images) ===
      JSON.stringify(nextProps.item.profile_images) &&
    JSON.stringify(prevProps.item.title) ===
      JSON.stringify(nextProps.item.title)
  );
});
